// Routing
export const HOME = '/';
export const ABOUT = '/about';
export const POLICY = '/policy';
export const BUSINESS = 'https://business.otetsutabi.com';
export const BUSINESSES = '/businesses';
export const CANCEL_POLICY = '/cancellation-policy';
export const CONTACT = '/contact';
export const FAVORITE_PLANS = '/favorite-plans';
export const FEATURE = '/features/:path';
export const USER_HISTORIES = '/user/histories';
export const FOLLOWING_BUSINESSES = '/following/businesses';
export const PLANS = '/plans';
export const PLAN = '/plans/:id';
export const ROOMS = '/rooms';
export const PASSWORD_RESET_NEW = '/password_reset/new';
export const PASSWORD_RESET_NEW_COMPLETE = '/password_reset/new/complete';
export const PASSWORD_RESET_EDIT = '/password_reset/edit';
export const PASSWORD_RESET_EDIT_COMPLETE = '/password_reset/edit/complete';
export const MYPAGE_PROFILE = '/mypage/profile';
export const MYPAGE_ACCOUNT = '/mypage/account';
export const USER_PAYMENT = '/user/payment';
export const USER_SCHEDULES = '/user/schedules';
export const USER_SKILLS = '/user/skills';
export const USER_PAYMENT_HISTORY = '/user/payment/history';
export const USERS_SIGNUP_CREATEACCOUNT = '';
export const TERMS_OF_SERVICE = '/terms-of-service';
export const PRIVACY_POLICY = '/privacy-policy';
export const CORP = '/corp';
export const SIGN_UP = '/users/signup';
export const LOGIN = '/users/login';
export const LOGOUT = '/users/logout';
export const LINE_AUTHORIZE = '/users/auth/line';
export const GOOGLE_AUTHORIZE = '/users/auth/google_oauth2';
export const FACEBOOK_AUTHORIZE = '/users/auth/facebook';
export const ONE_AUTHORIZE = '/users/auth/one';
export const PROVIDER_CONFIRM = '/users/provider/confirm';
export const PROVIDER_CONFIRM_COMPLETE = '/users/provider/confirm/complete';
export const REVIEW_PARTICIPANT = '/user/terms/:id/review';
export const NEWS_INDEX = '/news';
export const NEWS = '/news/:id';
export const USER_WITHHOLDINGS = '/user/withholdings';
export const APPLICANTS_CONFIRM = '/applicants/:id/confirm';
export const WITHDRAW = '/withdraw';
export const APP_VIEW = '/app_view';
export const APP_VIEW_BUSINESSES = `${APP_VIEW}/businesses`;
export const MCPR_TENRI = '/mcpr/tenri';
export const MCPR_USA = '/mcpr/usa';
export const MCPR_FUKUSHIMA = '/mcpr/fukushima';
export const MCPR_NISHIKAN = '/mcpr/nishikan';
export const MCPR_SHIZUOKA = '/mcpr/shizuoka';
export const MCPR_IMABARI = '/mcpr/imabari';
export const MCPR_BETSUKAI = '/mcpr/betsukai';
export const MCPR_ISHIKAWA = '/mcpr/ishikawa';
export const MCPR_TOBA = '/mcpr/toba';
export const MCPR_KOCHI = '/mcpr/kochi';

// front URL
export const BUSINESS_URL = `${process.env.FRONT_HOST}/businesses/:businessId`;

// admin URL
export const ADMIN_LOGIN_URL = `${process.env.ADMIN_HOST}/login`;

// API
// v1
export const API_V1_AUTH = '/api/v1/auth';
export const API_V1_FAVORITE_PLANS = '/api/v1/favorite_plans';
export const API_V1_INSTAGRAM_IMAGES = '/api/v1/instagram/images';
export const API_V1_PLANS = '/api/v1/plans';
export const API_V1_PLANS_FAVOR = '/api/v1/plans/:id/favor';
export const API_V1_PLANS_DISFAVOR = '/api/v1/plans/:id/disfavor';
export const API_V1_USER_PAYMENT_HISTORY = '/api/v1/user/payment/history';
export const API_V1_USERS_WITHDRAW = '/api/v1/users/withdraw';
export const API_V1_APPLICANTS = '/api/v1/applicants';
export const API_V1_APPLICANT_APPROVE =
  '/api/v1/applicants/:applicantId/approve';
export const API_V1_APPLICANT_REJECT = '/api/v1/applicants/:applicantId/reject';
export const API_V1_BANKS = '/api/v1/banks';
export const API_V1_BANK_BRANCHES = '/api/v1/banks/:bankId/bank_branches';
export const API_V1_BUSINESS_FOLLOW = '/api/v1/businesses/:id/follow';
export const API_BUSINESS_REVIEWS = '/api/businesses/:businessId/reviews';
export const API_CONTACT = '/api/contact';
export const API_PLAN = '/api/plans/:planId';
export const API_SURVEY_RESPONSES = '/api/survey_responses';
export const API_USER = '/api/user';
export const API_USER_CUSTOM_TOKEN = '/api/user/custom_token';
export const API_USER_PHONE = '/api/user/phone';
export const API_USER_CERTIFICATE = '/api/user/certificate';
export const API_USER_APPLICABLE_TERMS =
  '/api/v1/usersite/plans/:planId/applicable_terms';
export const API_PARTICIPANT_REVIEW = '/api/participants/:participantId/review';

// External
export const NOTE = 'https://note.com/otetsutabi';
export const EXPERIENCE =
  'https://media.otetsutabi.com/category/%e3%81%8a%e3%81%a6%e3%81%a4%e3%81%b3%e3%81%a8/';

// Methods for Link
// 関数で作成しているが、可能であればコンポーネントを定義したい。
// 利用規約か会社概要ページをSPA対応した際に、実際に関数で作成するかコンポーネントで作成するかを決定する
export const determineAppViewPath = (pathname: string): string => {
  // Webからの遷移の場合、pathnameをそのまま返す
  if (!window.location.pathname.includes(APP_VIEW)) return pathname;

  // WebView表示の場合は、WebView表示用のpathを返す
  return `${APP_VIEW}${pathname}`;
};
